import React, {useState} from 'react';
import {Button} from '@material-ui/core';
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import StyledButton from '../style'
import ClientAPI from "../../../api/clients";

function Preview(props) {
  const {setStep, valueForm, handleBack} = props
  const [disableButton, setDisableButton] = useState(false)
  const CustomStyleButton = StyledButton()
  const handleSubmit = () => {
    setDisableButton(true)
    valueForm.is_validate = false
    valueForm.name_client = `${valueForm.first_name_client}${valueForm.last_name_client}`
    valueForm.name_kana = `${valueForm.first_name_kana}${valueForm.last_name_kana}`
    ClientAPI.register(valueForm)
      .then(() => {
        setStep(3)
        window.scrollTo(0, 0)
      })
      .catch(async error => {
        setDisableButton(false)
        toast.error('エラーが発生しました', {toastId: 'error'})
      })
  }
  return (
    <div id='group-register'>
      <ToastContainer
        position='bottom-right'
        limit={1}
      />
      <div className='header' />
      <div className='content'>
        <span className='title'>お申し込み内容確認画面</span>
        <span className='description'>Dental.DX」の利用申込画面です。Dental.DXは歯科クリニック・医院から患者様へパーソナライズド動画送信を行うことができるコンソールシステムです。</span>
        <span className='description'>こちらに入力された個人情報はツールの利用開始にあたり使用するもので、第三者への開示・提供は一切いたしません。</span>
        <span className='description'>ご記入いただく情報はお客様情報として使用するため、正しく入力してください。</span>
        <span className='description highlight'>
          <ul className='notes'>
            <li className='notes'>
              こちらにご入力いただいたメールアドレスは、未配信のリマインドやエラー通知など「配信に関する重要なメールの受信先」として設定させていただきます。<br />
              今後システムをご使用いただく上で、確認しやすいメールアドレスをご入力ください。
            </li>
          </ul>
        </span>

        <div className='hr'/>
        
        <div className='group-form'>
          <div className='ml-30 label-input'>
            法人名（クリニック名）
          </div>
          <span className='w-67' >{valueForm.name_clinic}</span>
        </div>
        
        <div className='hr'/>
        
        <div className='group-form'>
          <div className='ml-30 label-input'>
            郵便番号
          </div>
          <span className='w-20'>{valueForm.postcode}</span>
        </div>
        <div className='group-form'>
          <div className='ml-30 label-input'>
            都道府県
          </div>
          <span className='w-29'>{valueForm.city}</span>
        </div>
        <div className='group-form'>
          <div className='ml-30 label-input'>
            住所
          </div>
          <span className='w-67'>{valueForm.address}</span>
        </div>
        
        <div className='hr'/>
        
        <div className='group-form'>
          <div className='ml-30 label-input'>
            電話番号
          </div>
          <span className='w-67'>{valueForm.tel}</span>
        </div>
        
        <div className='hr'/>
        
        <div className='group-form'>
          <div className='ml-30 label-input'>
            契約者氏名
          </div>
          <span className='w-29'>{valueForm.first_name_client}</span>
          <span className='w-29'>{valueForm.last_name_client}</span>
        </div>
        
        
        <div className='group-form'>
          <div className='ml-30 label-input'>
            契約者氏名フリガナ
          </div>
          <span className='w-29'>{valueForm.first_name_kana}</span>
          <span className='w-29'>{valueForm.last_name_kana}</span>
        </div>
        
        <div className="hr"/>
        
        <div className='group-form'>
          <div className='ml-30 label-input'>
            契約者メールアドレス
          </div>
          <span className='w-67'>{valueForm.email}</span>
        </div>
        
        <div className="hr"/>

        <div className='group-form'>
          <div className='ml-30 label-input'>
            お申し込みコード
          </div>
          <span className='w-67'>{valueForm.application_code}</span>
        </div>

        <div className="hr"/>
      </div>
      
      <div className='group-button'>
        <div className='checkbox-group'>
          <span>お申し込み内容をご確認の上、お申込みボタンを押してください。</span>
        </div>
        <div className='custom-button d-flex justify-content-center'>
          <Button
            onClick={handleBack}
            variant="contained"
            className='btn-back'
            classes={CustomStyleButton}>
            前の画面に戻る
          </Button>
          <Button
            disabled={disableButton}
            onClick={handleSubmit}
            variant="contained"
            className='btn-submit'
            classes={CustomStyleButton}>
            お申し込み
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Preview;
